import { ERROR_FETCH_ECONSENT, START_FETCH_ECONSENT, SUCCESS_FETCH_ECONSENT } from './actionTypes';
import * as econsentAPI from 'login-apis/econsentAPI';
import { createAction } from 'redux-actions';

const startGetEConsent = createAction(START_FETCH_ECONSENT);
const getEConsentSuccess = createAction(SUCCESS_FETCH_ECONSENT, content => content);
const getEConsentError = createAction(ERROR_FETCH_ECONSENT, () => 'Error fetching EConsent.');

export function getEConsentText() {
  return async function(dispatch) {
    dispatch(startGetEConsent());
    try {
      const res: any = await econsentAPI.getEConsent();
      dispatch(getEConsentSuccess(res.data.htmlText as string));
    } catch (err) {
      dispatch(getEConsentError());
    }
  };
}
